import React from 'react'
import { SaleValue, Text } from 'components'
import classNames from 'classnames'
import styles from './SaleValueText.module.scss'

const SaleValueText = ({
  show = true,
  value,
  saleLabel,
  propertyCard = false,
  asterisk = false,
  fontSize = 'regular',
  isCampaign = false,
  className = '',
}) =>
  show && (
    <span
      className={classNames(styles.saleValueText, className, {
        [styles.propertyCard]: propertyCard,
      })}
    >
      <Text
        className={classNames(styles.text, {
          [styles.propertyCard]: propertyCard,
          [styles.campaign]: isCampaign,
          [styles.saldao]: saleLabel === 'Valor Saldão',
        })}
      >
        {saleLabel}
      </Text>
      <SaleValue
        value={value}
        asterisk={asterisk}
        fontSize={fontSize}
        isCampaign={isCampaign}
      />
    </span>
  )

export default React.memo(SaleValueText)
